import { addEdgeLips, breakPath, mirrorX, setDefaultStyle } from "apparatus/draw";
import { interpolate, Segments } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
import { createTap, Tap } from "./common/tap";
export class SeparatoryFunnel {
    render(appearance) {
        let size = appearance.size;
        const outflowHeight = 50;
        let glass;
        let closeTap;
        let breakPathIndex;
        if (appearance.shape === "long") {
            let halfRadius = size * 0.25;
            glass = new Path(Segments([[0, -20]], [[0, 0], undefined, [-halfRadius, 10]], // Start of arc
            [[-halfRadius, halfRadius * 0.7], undefined, [0, 20]], // end of arc
            [[7, size]], [[7, size + outflowHeight]]));
            mirrorX(glass, 12);
            closeTap = [5, 3];
            breakPathIndex = 6;
        }
        else {
            // Round - boost the size
            size += 40;
            const midRadiusOffset = interpolate(size, [100 + 40, 200 + 40], [6, 0]);
            const radius = size * 0.15 + 8;
            glass = new Path(Segments([[0, -20]], [[0, 0], undefined, [-radius * 0.4, radius * 0.1]], // Start of bulb
            [[-radius + 12, radius], [0, -radius * 0.55], [0, radius * 0.4]], [[midRadiusOffset, 2.4 * radius], [0, -radius * 0.15],], // end of arc
            [[midRadiusOffset, size - 15], , [0, 5]], [[7, size]], // Close tap here
            [[7, size + outflowHeight]]));
            mirrorX(glass, 12);
            closeTap = [7, 5];
            breakPathIndex = 8;
        }
        let liquidMask = glass.clone();
        // Adjust liquidMask based on opening.
        const isClosed = Tap.isClosed(appearance.tapOpening);
        if (isClosed) {
            liquidMask.segments[closeTap[0]].point = liquidMask.segments[closeTap[1]].point;
        }
        addEdgeLips(glass);
        let glassWalls = breakPath(glass, breakPathIndex);
        setDefaultStyle(glassWalls);
        let stopCock = createTap(appearance);
        stopCock.position.x += 12;
        stopCock.position.y = size + 2;
        let graphic = new Group([glassWalls, stopCock]);
        var hitShapes = [
            Shape.Rectangle(glass.bounds),
            Shape.Rectangle(stopCock.bounds)
        ];
        let liquidDrainOpening;
        if (!isClosed) {
            if (appearance.shape === "long") {
                liquidDrainOpening = {
                    start: liquidMask.segments[4].point,
                    end: liquidMask.segments[5].point,
                };
            }
            else {
                liquidDrainOpening = {
                    start: liquidMask.segments[6].point,
                    end: liquidMask.segments[7].point,
                };
            }
        }
        return {
            graphic,
            hitShape: hitShapes,
            liquidMask,
            liquidDrainOpening,
        };
    }
}
SeparatoryFunnel.properties = {
    label: "Separatory Funnel",
    canContainLiquids: true,
    drainable: true,
    defaultAppearance: Object.assign({ size: 150, shape: "long" }, Tap.defaultAppearance),
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 100, max: 200
        },
        {
            spec: "toggle-buttons", key: "shape", label: "Shape", size: "text",
            allowSelectingTierLockedOptions: true,
            options: [
                { value: "long", label: "Long", },
                { value: "round", label: "Round", tier: "boost" },
            ]
        },
        ...Tap.appearanceSpecsWithFacing,
    ],
    isBoostRequired: a => a.shape === "round"
};
